import { render, staticRenderFns } from "./FormTemplateMultipleChoiceQuestion.vue?vue&type=template&id=b6973628&scoped=true&"
import script from "./FormTemplateMultipleChoiceQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateMultipleChoiceQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6973628",
  null
  
)

export default component.exports